/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SequenceRulesInterestedAction } from './sequenceRulesInterestedAction';
import type { SequenceRulesNotInterestedAction } from './sequenceRulesNotInterestedAction';

/**
 * Per-sequence rules block (spec §7).
 */
export interface SequenceRules {
  pause_on_out_of_office?: boolean;
  interested_action?: SequenceRulesInterestedAction;
  interested_stage_id?: string | null;
  interested_auto_draft_enabled?: boolean;
  interested_auto_draft_instructions?: string | null;
  not_interested_action?: SequenceRulesNotInterestedAction;
  not_interested_stage_id?: string | null;
  not_interested_auto_draft_enabled?: boolean;
  not_interested_auto_draft_instructions?: string | null;
  /** @maxItems 20 */
  cc_emails?: string[];
  /** @maxItems 20 */
  bcc_emails?: string[];
}
